import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { queries } from '~/keys';
import type { HoldDto } from '~/server/utils/exclusives/holds/holdSnapshot';
import type { HoldRequestBody } from '~/utils/exclusives/holdDialog';

export type HoldUnitPayload = { catalogueProjectId: number; catalogueUnitId: number; body: HoldRequestBody };

type HoldUnitResponse = { success: true; data: { hold: HoldDto; serverNow: string } };

// POST hold (ID-119). Errors are shown inline in the dialog (holdErrorCopy), not as a global toast.
export const useHoldExclusiveUnit = () => {
  const authStore = useAuthStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ catalogueProjectId, catalogueUnitId, body }: HoldUnitPayload) =>
      $fetch<HoldUnitResponse>(`/api/exclusives/${catalogueProjectId}/units/${catalogueUnitId}/hold`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${authStore.token}` },
        body,
      }).then((res) => res.data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queries.exclusiveUnits.myHolds.queryKey }),
  });
};
